import React from "react";

import { Link, ListItem } from "@catchoftheday/cg-components";
import { styled, themeGet } from "@catchoftheday/theme";

import { NavigationItem } from "@header/types";

import { ItemPath, trackMenuClick } from "../../utilities/analytics";

const StyledLink = styled(Link)`
  color: ${(props) => themeGet("colors.typography.text")(props)};
  font-size: ${(props) => themeGet("fontSizes.xs")(props)};
  font-weight: ${(props) => themeGet("fontWeights.light")(props)};
  word-wrap: break-word;
  transition: none;

  &:hover,
  &:focus,
  &:active {
    text-decoration: none;
  }
`;

type MenuLinkProps = {
  navItem: NavigationItem;
  itemPathLink: ItemPath[];
};

export const MenuLink = ({ navItem, itemPathLink }: MenuLinkProps) => {
  return (
    <ListItem key={navItem.id} m="0" pb="4.5px" lineHeight="1.15rem">
      <StyledLink
        tabIndex={-1}
        id={`menu-link-${navItem.name}-${navItem.id}`}
        href={navItem.url}
        onClick={() =>
          trackMenuClick({
            name: navItem.name,
            url: `${location.origin}${navItem.url}`,
            item_path: itemPathLink,
          })
        }
      >
        {navItem.name}
      </StyledLink>
    </ListItem>
  );
};
